<template>
    <form v-on:submit.prevent="search">
        <input type="text" class="col-12 border-0 sans-s p-2 pl-3" v-model="qp" v-on:keyup="search">
    </form>
</template>

<script>
    import { mapActions } from "vuex";
    
    export default {
        name: "ClassicSearch",
        data() {
            return {
                qp: '',
                delay: undefined
            }
        },
        methods: {
            search: function(e) {
                clearTimeout(this.$data.delay);
                if (e.keyCode === 13) {
                    this.getPosts({qp:this.$data.qp});
                } else if (e.keyCode === 27) {
                    this.$data.qp = '';
                    this.getPosts({qp:''});
                } else {
                    this.$data.delay = setTimeout(() => {
                        this.getPosts({qp:this.$data.qp});
                    }, 100)
                }
            },
            ...mapActions([
                "getPosts", 
            ]),
        },
    };
</script>